import {Card, CardBody, CardHeader, Table, TableContainer, Tbody, Td, Th, Thead, Tr, Text, Center} from '@chakra-ui/react'

interface TableCardProps {
  cardHeader?: React.ReactNode
  headers: (string | React.ReactNode)[]
  data?: (string | React.ReactNode)[][]
  emptyStateText?: string
}

export const TableCard = ({cardHeader, headers, data, emptyStateText = 'No data available'}: TableCardProps) => {
  return (
    <Card bg="white" boxShadow="base" rounded="lg" w="full">
      {cardHeader && <CardHeader>{cardHeader}</CardHeader>}
      <CardBody p={0}>
        <TableContainer>
          <Table variant="simple">
            <Thead>
              <Tr>
                {headers.map((header, idx) => (
                  <Th key={idx}>{header}</Th>
                ))}
              </Tr>
            </Thead>
            <Tbody>
              {data && data.length > 0 ? (
                data.map((row, idx) => (
                  <Tr key={idx}>
                    {row.map((cell, colIdx) => (
                      <Td key={colIdx}>{cell}</Td>
                    ))}
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan={headers.length}>
                    <Center py={8}>
                      <Text color="gray.500">{emptyStateText}</Text>
                    </Center>
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </TableContainer>
      </CardBody>
    </Card>
  )
}
